import styles from './PageLoader.module.scss';
import PropTypes from 'prop-types';

function PageLoader({ fullPage, minHeight }) {
  return (
    <div
      className={fullPage ? styles.fullPage : styles.inline}
      style={!fullPage && minHeight ? { minHeight } : undefined}
      role="status"
      aria-label="Loading"
    >
      <p className={styles.loadingText}>Loading...</p>
    </div>
  );
}

PageLoader.propTypes = {
  fullPage: PropTypes.bool,
  minHeight: PropTypes.string,
};

PageLoader.defaultProps = {
  fullPage: false,
  minHeight: '200px',
};

export default PageLoader;
